import styled from "styled-components";

import { COVERS_HALFCARD_CONSTANTS } from "./constant";

// The half-card is fixed to bottom:0 and the keyboard overlays the layout viewport (it does not
// resize it), so the input/CTA would sit behind the keyboard. useKeyboardState publishes the
// keyboard height as --ios-keyboard-height (raw px number, reset to 0 on close); adding it to the
// bottom padding lifts the whole card content above the keyboard. When the keyboard is closed the
// var is unset → 0. This is the sole lift mechanism for this card (no data-keyboard-scroll / <body>
// transform), which avoids the double-lift + internal scroll the body transform produced.
export const Container = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.large,
    alignItems: "stretch",
    paddingBottom: `calc(var(--sab, 0px) + ${theme.spacing.large} + (var(--ios-keyboard-height, 0) * 1px))`,
}));

export const IllustrationContainer = styled.div({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
});

export const IconWrapper = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: COVERS_HALFCARD_CONSTANTS.ICON_WRAPPER_SIZE,
    height: COVERS_HALFCARD_CONSTANTS.ICON_WRAPPER_SIZE,
    borderRadius: theme.cornerRadius.rounded,
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
    boxShadow: theme.elevation[theme.colorMode].skim.boxShadow,
}));

export const TextContainer = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.xSmall,
    alignItems: "center",
    textAlign: "center",
}));

export const InputWrapper = styled.div(({ theme }) => {
    const { fontSize, fontWeight, lineHeight, fontFamily, letterSpacing } =
        theme.typography["V2.body3.neutral.medium"];
    const inputTypography = { fontSize, fontWeight, lineHeight, fontFamily, letterSpacing };
    return {
        width: "100%",
        "& input": inputTypography,
        "& input::placeholder": inputTypography,
    };
});

export const CTAWrapper = styled.div({
    width: "100%",
});
